/**
 * Page dependencies module containing all conditional logic functions used to
 * determine whether specific pages or content should be rendered based on form data.
 * These "depends" functions evaluate form state to control page visibility and content
 * conditionally throughout the application.
 */

export const isActivelyServing = formData =>
  formData?.serviceInformation?.serviceComponent?.active === true;

export const isServingComponentGuardAndReserves = formData =>
  formData?.serviceInformation?.serviceComponent?.reserves === true &&
  formData?.serviceInformation?.serviceComponent?.nationalGuard === true;

export const isServingComponent = formData =>
  formData?.serviceInformation?.serviceComponent?.reserves === true ||
  formData?.serviceInformation?.serviceComponent?.nationalGuard === true;

export const isCurrentlyActivated = formData =>
  isServingComponent(formData) === true &&
  formData?.serviceInformation?.federalActivation?.currentlyActivated === true;

export const isReceivingServicePay = formData =>
  formData?.serviceInformation?.isReceivingServicePay === true;

export const isMilitaryRetiredPay = formData =>
  formData?.['view:servicePayType']?.['view:militaryRetiredPay'] === true;

export const isTrainingPay = formData =>
  formData?.['view:servicePayType']?.['view:trainingPay'] === true;

export const hasDirectDeposit = formData =>
  formData?.directDeposit?.hasNoAccount === false;

export const hasPrefilledBankAccount = formData =>
  formData?.['view:hasPrefilledBankAccount'] === true;
